import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './header.css';
import { Logo } from './components/logo';
import { WithSeparator } from './components/with-separator';
import { useAuth } from './auth-context';
let config = require('../cc-config.json');
function getCurrentMenuLinks(username) {
    return [
        [
            ...(username != undefined ?
                [
                    {
                        to: "/my-account.html",
                        text: `Account (${username})`
                    }
                ] :
                [
                    {
                        to: "/login.html",
                        text: "Log in"
                    }
                ])
        ],
        [
            {
                to: "/view/categories",
                text: "View Maps"
            },
            {
                to: "/edit/categories",
                text: "Edit Maps"
            },
            {
                to: "/data-extracts.html",
                text: "Download data"
            },
            {
                to: "https://github.com/colouring-cities/manual/wiki",
                text: "Colouring Cities Open Manual/Wiki",
                external: true
            },
            {
                to: "https://colouringcities.org/impact-studies",
                text: "Impact Study Showcase",
                external: true
            },
        ],
        [
            {
                to: "https://github.com/colouring-cities/manual/wiki/A.-ABOUT",
                text: "About the Colouring Cities Research Programme",
                external: true
            },
            {
                to: "/about.html",
                text: "About the Colouring " + config.cityName + " Project",
            },
            {
                to: "/data-categories.html",
                text: "Data Categories",
            },
            {
                to: "https://github.com/colouring-cities/manual/wiki/ETHICAL-FRAMEWORK",
                text: "Ethical Framework",
                external: true
            },
        ],
        [
            {
                to: "/leaderboard.html",
                text: "Top Contributors"
            },
            {
                to: config.githubURL + "/discussions",
                text: "Discussion Forum (GitHub)",
                external: true
            },
        ],
        [
            {
                to: "/privacy-policy.html",
                text: "Privacy Policy",
            },
            {
                to: "/data-accuracy.html",
                text: "The Data Accuracy Agreement",
            },
            {
                to: "/code-of-conduct.html",
                text: "Code of Conduct",
            },
            {
                to: "/contributor-agreement.html",
                text: "Contributor Agreement",
            },
        ],
        [
            {
                to: "/contact.html",
                text: "Contact"
            },
        ],
    ];
}
const Menu = ({ onNavigate }) => {
    const { user } = useAuth();
    const menuLinkSections = getCurrentMenuLinks(user === null || user === void 0 ? void 0 : user.username);
    return (React.createElement(WithSeparator, { separator: React.createElement("hr", null) }, menuLinkSections.map((section, idx) => React.createElement("ul", { key: `menu-section-${idx}`, className: "navbar-nav flex-container" }, section.map(item => {
        var _a;
        return (React.createElement("li", { className: 'nav-item', key: `${item.to}-${item.text}` }, item.disabled ?
            React.createElement(LinkStub, { note: (_a = item.note) !== null && _a !== void 0 ? _a : '' }, item.text) :
            item.external ?
                React.createElement(ExternalNavLink, { to: item.to }, item.text) :
                React.createElement(InternalNavLink, { to: item.to, onClick: onNavigate }, item.text)));
    })))));
};
const InternalNavLink = ({ to, onClick, children }) => (React.createElement(NavLink, { className: "nav-link", to: to, onClick: onClick }, children));
const ExternalNavLink = ({ to, children }) => (React.createElement("a", { className: "nav-link", href: to, target: "_blank", rel: "noopener noreferrer" }, children));
const LinkStub = ({ note, children }) => (React.createElement("a", { className: "nav-link disabled" },
    children,
    React.createElement("span", { className: "link-note" }, note)));
export const Header = ({ animateLogo }) => {
    const [collapseMenu, setCollapseMenu] = useState(true);
    const toggleCollapse = () => setCollapseMenu(!collapseMenu);
    const handleNavigate = () => setCollapseMenu(true);
    return (React.createElement("header", { className: "main-header navbar navbar-light" },
        React.createElement("div", { className: "nav-header" },
            React.createElement(NavLink, { to: "/" },
                React.createElement(Logo, { variant: animateLogo ? 'animated' : 'default' })),
            React.createElement("button", { className: "navbar-toggler", type: "button", onClick: toggleCollapse, "aria-expanded": !collapseMenu, "aria-label": "Toggle navigation" },
                "Menu\u00A0",
                collapseMenu ?
                    React.createElement("span", { className: "navbar-toggler-icon" })
                    : React.createElement("span", { className: "close" }, "\u00D7"))),
        React.createElement("nav", { className: collapseMenu ? 'collapse navbar-collapse' : 'navbar-collapse' },
            React.createElement(Menu, { onNavigate: handleNavigate }))));
};
